import apiClient from '../client'
import type { PageResponse } from '../types'
import type { OcrMonthlyUsageRecord, OcrSuccessStatsResponse } from './types'

export const ocrSuccessStatsApi = {
  list(params?: {
    municipalityCode?: string
    municipalityName?: string
    importNo?: string
    identId?: string
    householdIdentCode?: string
    fileName?: string
    dateFrom?: string
    dateTo?: string
    sortBy?: string
    order?: 'ASC' | 'DESC'
    page?: number
    size?: number
  }) {
    return apiClient.get<OcrSuccessStatsResponse>('/api/admin/ocr-success-stats', { params })
  },

  exportCsv(params?: {
    municipalityCode?: string
    municipalityName?: string
    importNo?: string
    identId?: string
    householdIdentCode?: string
    fileName?: string
    dateFrom?: string
    dateTo?: string
    sortBy?: string
    order?: 'ASC' | 'DESC'
  }) {
    return apiClient.get('/api/admin/ocr-success-stats/export', {
      params,
      responseType: 'blob',
    })
  },

  // 自治体 × 月の用量集計（取込分／取込成功分）。
  listMonthly(params?: {
    municipalityCode?: string
    municipalityName?: string
    dateFrom?: string
    dateTo?: string
    sortBy?: string
    order?: 'ASC' | 'DESC'
    page?: number
    size?: number
  }) {
    return apiClient.get<PageResponse<OcrMonthlyUsageRecord>>('/api/admin/ocr-success-stats/monthly', { params })
  },

  exportMonthlyCsv(params?: {
    municipalityCode?: string
    municipalityName?: string
    dateFrom?: string
    dateTo?: string
    sortBy?: string
    order?: 'ASC' | 'DESC'
  }) {
    return apiClient.get('/api/admin/ocr-success-stats/monthly/export', {
      params,
      responseType: 'blob',
    })
  },
}
